










import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import { State, Action, namespace } from 'vuex-class'
const commonModules = namespace('commonModules')
import { Protocol } from '@/components'
@Component({
  name: 'productSever',
  components: {
    Protocol
  }
})
export default class productSever extends Vue {
  @commonModules.State paySeverHtml: any
  @commonModules.State loadingPage
  htmlData: string = ''
  @Watch('paySeverHtml', { immediate: true })
  onChanged(val: any) {
    this.htmlData = val && val[0] && val[0]['compContent']
  }
}
